module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av40-eec8757cd948fc5a4cbacb969ce483b8.jpg";